import * as React from 'react';

import { Breadcrumbs } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

type Props = {
  programSlug: string;
  programName: string;
  learningPathName: string;
  badgeTemplateSlug: string;
};

const LearningPathBreadcrumbs = ({ programSlug, programName, learningPathName, badgeTemplateSlug }: Props) => {
  return (
    <Breadcrumbs>
      <Breadcrumbs.Item href={`/programs/${programSlug}`}>{_t('All learning programs')}</Breadcrumbs.Item>
      <Breadcrumbs.Item href={`/programs/${programSlug}`}>{programName}</Breadcrumbs.Item>
      <Breadcrumbs.Item href={`/programs/${programSlug}/learning-path/${badgeTemplateSlug}`}>
        {learningPathName}
      </Breadcrumbs.Item>
    </Breadcrumbs>
  );
};

export default LearningPathBreadcrumbs;
